"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentCompositor = void 0;
const compositor_1 = require("./compositor");
class EnvironmentCompositor extends compositor_1.Compositor {
    constructor(config) {
        super({
            videoStarter: config.videoStarter,
            stats: config.stats,
        });
        this.toolEngine = config.toolEngine;
    }
    postProcessingHook(context) {
        this.toolEngine.render(context);
    }
    stopCompositingHook() {
        this.toolEngine.disconnect();
    }
}
exports.EnvironmentCompositor = EnvironmentCompositor;
//# sourceMappingURL=environment_compositor.js.map